import * as React from 'react';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { Input } from '../../../components/forms/Input';
import { Select } from '../../../components/forms/Select';
import { UserOrganizationRole } from '../../../models/graphql';
import { GetOrganization_organization } from '../../../models/legacy-graphql';
import classes from './InviteTeamMemberModal.module.scss';
import classesForm from '../../../components/forms/form.module.scss';
import { Checkbox } from '../../../components/forms/Checkbox';
import { FormModal } from '../../../components/containers/FormModal';
import { SelectItem } from '../../../components/forms/Select/Select.view';
import { InputTypes } from '../../../constants/form';

export type SubmittedDataInviteTeamMemberFormType = {
  email: string;
  role: UserOrganizationRole;
  workspaces: Array<string | false>;
};

export type InviteTeamMemberModalViewProps = {
  onClose: () => void;
  onSubmit: (data: SubmittedDataInviteTeamMemberFormType) => void;
  submitted: boolean;
  emailRules: RegisterOptions;
  roleRules: RegisterOptions;
  workspaceRules: RegisterOptions;
  organization: GetOrganization_organization;
  selectedOrgRole: UserOrganizationRole | null;
  useFormInstance: UseFormReturn;
};

export const InviteTeamMemberModalView = (props: InviteTeamMemberModalViewProps): JSX.Element => {
  const role = props.useFormInstance.watch('role');
  const initialWatchValues: Array<string | false> = props.organization.workspaces.map(workspace => workspace.id);
  const workspaceCheckboxes: Array<string | false> = props.useFormInstance.watch('workspaces', initialWatchValues);

  const ListOfWorkspaces = props.organization.workspaces.map((workspace, index) => {
    return (
      <div key={`wskey-${workspace.id}`} className={'margin-top-small-8 margin-bottom-small-8'}>
        <Checkbox
          id={`ws-checkbox-${workspace.id}`}
          formInstance={props.useFormInstance}
          name={`workspaces.${index}`}
          rules={props.workspaceRules}
          size={'large'}
          label={workspace.name}
          value={workspace.id}
          readonly={
            (workspaceCheckboxes?.filter(value => !!value).length < 2 && !!workspaceCheckboxes[index]) ||
            props.submitted
          }
        />
      </div>
    );
  });

  const selectOptions: SelectItem[] = [
    {
      label: 'Editor',
      value: UserOrganizationRole.EDITOR
    }
  ];

  if (props.selectedOrgRole === UserOrganizationRole.OWNER) {
    selectOptions.push({
      label: 'Admin',
      value: UserOrganizationRole.ADMIN
    });
  }

  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      formInstance={props.useFormInstance}
      loading={props.submitted}
      onSubmit={props.onSubmit}
      submitText={'Send Invitation'}
      title={'Invite a Team Member'}>
      <div className={'margin-bottom-small-16'}>
        <Input
          disabled={props.submitted}
          formInstance={props.useFormInstance}
          name={'email'}
          type={InputTypes.email}
          size={'large'}
          label={`Email`}
          rules={props.emailRules}
        />
      </div>
      <div className={'margin-bottom-small-16'}>
        <Select
          items={selectOptions}
          selectedValue={UserOrganizationRole.EDITOR}
          label={'Role'}
          name={'role'}
          useFormInstance={props.useFormInstance}
          size={'large'}
          rules={props.roleRules}
          readonly={props.selectedOrgRole !== UserOrganizationRole.OWNER || props.submitted}
        />
      </div>
      <div>
        <div className={classesForm.Label}>Workspace Permissions</div>
        <div className={classes.WorkspacesContainer}>
          {role === UserOrganizationRole.ADMIN ? (
            <div>All Workspaces</div>
          ) : (
            <div className={'grid-y'}>{ListOfWorkspaces}</div>
          )}
        </div>
      </div>
    </FormModal>
  );
};
